import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnInit
} from '@angular/core';

import { IrisBaseModalComponent } from './base-modal/base-modal.component';
import { IrisModalRef } from './utilities/modal-ref';

@Component({
  selector: 'iris-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  standalone: false
})
export class IrisModalComponent<TContent, TModalInputs, TResponseData>
  extends IrisBaseModalComponent<TContent, TModalInputs, TResponseData>
  implements OnInit, AfterViewInit {
  title: string = '';
  showTitle: boolean = true;
  ariaLabel: string = '';
  showHeader: boolean = true;
  isDismissable: boolean = true;
  closeOnBackdropClick: boolean = false;

  @HostBinding('style')
  get customStyles(): Record<string, string> {
    return this.ref.config.customStyles ?? {};
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(
    focusTrapFactory: ConfigurableFocusTrapFactory,
    hostElement: ElementRef,
    ref: IrisModalRef<TContent, TModalInputs, TResponseData>
  ) {
    super(focusTrapFactory, hostElement, ref);
  }

  ngOnInit(): void {
    this.title = this.ref.config.title ?? '';
    this.showTitle = this.ref.config.showTitle ?? true;
    this.ariaLabel = this.ref.config.ariaLabel ?? '';
    this.showHeader = this.ref.config.showHeader ?? true;
    this.isDismissable = this.ref.config.isDismissable ?? true;
    this.closeOnBackdropClick = this.ref.config.closeOnBackdropClick ?? false;

    this.initializeModalContent();
  }

  close(): void {
    this.ref.close();
  }
}
